import request from '@/utils/request'

let CouponApi = {

  /*优惠券列表*/
  couponList(data) {
    return request._post('/shop/plus.coupon.coupon/index', data);
  },
  /*添加优惠券*/
  addCoupon(data) {
    return request._post('/shop/plus.coupon.coupon/add', data);
  },
  /*获取优惠券信息*/
  couponDetail(data) {
    return request._post('/shop/plus.coupon.coupon/couponDetail', data);
  },
  /*修改优惠券*/
  editCoupon(data) {
    return request._post('/shop/plus.coupon.coupon/edit', data);
  },
  /*删除优惠券*/
  deleteCoupon(data) {
    return request._post('/shop/plus.coupon.coupon/delete', data);
  },
  /*优惠券领取记录*/
  receiveList(data) {
    return request._post('/shop/plus.coupon.coupon/receive', data);
  },
  /*去发送优惠券*/
  toSendCoupon(data) {
    return request._get('/shop/plus.coupon.coupon/SendCoupon', data);
  },
  /*发送优惠券*/
  SendCoupon(data) {
    return request._post('/shop/plus.coupon.coupon/SendCoupon', data);
  },
  // 获取会员等级
  getGradeList(data) {
    return request._post('/shop/plus.coupon.coupon/getGradeList', data);
  },
}

export default CouponApi;



// WEBPACK FOOTER //
// ./src/api/coupon.js